const Error = ({ ...props }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M18 2L2 18M2 2L18 18"
                stroke="#FFF5E7"
                strokeWidth="4"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default Error
